import { render } from "./MyAppointmentSection.vue?vue&type=template&id=e5243414&scoped=true"
import script from "./MyAppointmentSection.vue?vue&type=script&lang=js"
export * from "./MyAppointmentSection.vue?vue&type=script&lang=js"

import "./MyAppointmentSection.vue?vue&type=style&index=0&id=e5243414&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5243414"]])

export default __exports__